import React, {Component} from "react";
import {Input, Modal, ModalBody, ModalHeader} from "reactstrap";
import {request} from "../../helper/APIUtils";
import {showAxiosError} from "../../helper/helper";
import Alert from "react-s-alert";


    class AddTagList extends Component {
    constructor(props) {
        super(props);
        this.state = {

            customizerModal: true,
            isAll: false,
            value: null,
            rowId: null,
            prevState: null,
            valid: null,
            tagTypeName:null,
            defineTagList:[]

        };

      this.closeCustomizerModal = this.closeCustomizerModal.bind(this);
      this.openCustomizerModal = this.openCustomizerModal.bind(this);
      this.addtag = this.addtag.bind(this);
      this.onValueChange = this.onValueChange.bind(this);
      this.onValueTypeChange = this.onValueTypeChange.bind(this);
      this.getTagName = this.getTagName.bind(this);

    }

    openCustomizerModal() {

        this.setState({customizerModal: true, isAll: true});
    }

    closeCustomizerModal() {

        this.setState({customizerModal: false});
        this.props.closeClick();
    }

    addtag()
    {   let self = this;
        let tagName = this.state.value;
        let type = this.state.rowId;
        if((tagName != null  && tagName !=="") && type != null) {
            let params = {
                url: 'tag/save',
                method: 'post',
                data: {tagName, type},
            };
            request(params)
                .then(function (response) {
                    Alert.success("İşaret başarılı bir şekilde eklendi.", {
                        position: 'top-right',
                        effect: 'stackslide',
                        timeout: 1500,
                        html:false
                    });
                    self.setState({value: ""});
                    self.closeCustomizerModal();
                }).catch(function (error) {
                showAxiosError({response: error.response});
                self.setState({loading: false, searching: false});
            });
        }else {
            showAxiosError({message: "İşaret adı ve türü alanlarını doldurunuz."});
        }
    }

    onValueChange (e) {
       this.setState({value:e.target.value});
    }

    onValueTypeChange(event){
        const target = event.target;
        let value = target.type === 'checkbox' ? target.checked : target.value;

            {value === 'Giden İrsaliye' &&
                 this.setState({tagTypeName :'Giden İrsaliye',rowId:0});
            }
            {value === 'Gelen İrsaliye' &&
                this.setState({tagTypeName : 'Gelen İrsaliye', rowId:1});
            }
            {value === 'Giden E-Fatura' &&
                this.setState({tagTypeName : 'Giden E-Fatura', rowId:2});
            }
            {value === 'Gelen E-Fatura' &&
                this.setState({tagTypeName : 'Gelen E-Fatura', rowId:3});
            }
            {value === 'E-Arşiv Fatura' &&
                this.setState({tagTypeName : 'E-Arşiv Fatura', rowId:4});
            }
            {value === 'E-Müstahsil Makbuzlar' &&
                this.setState({tagTypeName : 'E-Müstahsil Makbuzlar', rowId:5});
            }
            {value === 'E-Serbest Meslek Makbuzlar' &&
                this.setState({tagTypeName : 'E-Serbest Meslek Makbuzlar', rowId:6});
            }
            {value === 'E-Gider Pusulası' &&
                this.setState({tagTypeName : 'E-Gider Pusulası', rowId:7});
            }
            {value === 'E-Adisyon' &&
                this.setState({tagTypeName : 'E-Adisyon', rowId:8});
            }
            {value === 'E-Sigorta' &&
                this.setState({tagTypeName : 'E-Sigorta', rowId:9});
            }
            {value === 'E-Döviz' &&
                this.setState({tagTypeName: 'E-Döviz', rowId: 11});
            }

        }

    getTagName(){
         let defineTagList = [];
         if(this.props.hasEirsaliye != null){
             defineTagList.push({key:0 , value:'Giden İrsaliye'});
             defineTagList.push({ key:1 , value:'Gelen İrsaliye'});
         }
        if(this.props.hasEFatura != null){
             defineTagList.push({  key:2 , value:'Giden E-Fatura'});
             defineTagList.push({  key:3 , value:'Gelen E-Fatura'});
         }
        if(this.props.hasEarsiv != null){
             defineTagList.push({key:4 , value:'E-Arşiv Fatura'});
         }
        if(this.props.hasEmuhtahsil != null){
             defineTagList.push({ key:5 , value:'E-Müstahsil Makbuzlar'});
         }
        if(this.props.hasEserbestmeslek != null){
            defineTagList.push({ key:6 , value:'E-Serbest Meslek Makbuzlar'});
         }
        if(this.props.hasEgiderPusulasi != null){
            defineTagList.push({ key:7 , value:'E-Gider Pusulası'});
        }
        if(this.props.hasEAdisyon != null){
            defineTagList.push({ key:8 , value:'E-Adisyon'});
        }
        if (this.props.hasExchange != null) {
            defineTagList.push({key: 11, value: 'E-Döviz'});
        }

        this.setState({defineTagList});
    }

    componentDidMount () {
        this.getTagName();
     }
     render()
        {

            return (
                <div>
                 <Modal isOpen={this.state.customizerModal} size={'lg'}>
                    <ModalHeader toggle={this.closeCustomizerModal}> İşaret Ekle </ModalHeader>
                    <ModalBody>
                        <div className="row" style={{padding:"0px 20px"}}>
                            <label style={{fontSize:"15px"}} className="col-sm-2">İşaret Adı:</label>
                            <input className="form-control col-sm-4 "
                                   type="text"
                                   pattern="[0-9]*"
                                   value={this.state.value}
                                   onChange={(e) => this.onValueChange(e)}/>

                            <label style={{fontSize:"15px"}} className="col-sm-2">İşaret Türü:</label>
                                <Input className="col-sm-4" type="select" name="defineType" style={{maxHeight:"28px"}} value={this.state.tagTypeName} onChange={(e)=>this.onValueTypeChange(e)} >
                                    <option value="">Seçiniz</option>
                                    {Object.keys(this.state.defineTagList).map((elem,i) => <option key={i} value={this.state.defineTagList[i].value}>{this.state.defineTagList[i].value}</option>)}
                                </Input>

                        </div>
                        <div className="col-sm-12" >

                            <div className="col-sm-3 float-right">
                                <button type="button" data-toggle="tooltip" data-placement="bottom"
                                        style={{background: 'linear-gradient(rgba(159, 208, 55, 0.6), #9fd037)'}}
                                        rel="tooltip" className="TekBtn ekle float-right mt-2"
                                        onClick={(e) => this.addtag()}>
                                İşaret Ekle
                                </button>
                            </div>
                        </div>
                    </ModalBody>

                </Modal>
                </div>
            );
        };
}



export default AddTagList;